module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8ZyBpZD0i5qWV5YaG5b2iXzExMCIgZGF0YS1uYW1lPSLmpZXlhoblvaIgMTEwIiBmaWxsPSIjZmEzZDNkIiBzdHJva2U9IiNmYTNkM2QiIHN0cm9rZS13aWR0aD0iMSI+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgc3Ryb2tlPSJub25lIi8+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iNy41IiBmaWxsPSJub25lIi8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/phenotypePathIcons/0-path-icon.svg
// module id = kTy6
// module chunks = 5